// extracted by mini-css-extract-plugin
module.exports = {"modal":"ModalComponentPortal_modal__1q25U","modal_content":"ModalComponentPortal_modal_content__2zaxY"};